module.exports = __webpack_public_path__ + "static/pokoj-nr5-photo07-2361292a8b150a97bf17d22ebcfa439b.jpg";